module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/**SitePage Scene */

(function(fox) { fox.registerWidget('SitePage_Scene', {}, 'Site_Page'); })(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./widget/sitepage/scene.js
// module id = 1281
// module chunks = 4